import {useAuth0} from "@auth0/auth0-react";
import {getAdminServer} from "./Util/HostUtils";
import {space} from "./compiled";
import RequestEnvelopeProto = space.kenko.proto.RequestEnvelopeProto;
import {useKensuAuth} from "./Util/AuthWrapper";

type RpcSender = {
  send: (method: string, request: Uint8Array) => Promise<Uint8Array>;
}

export const useRpcSender = (): RpcSender => {

  const {getIdTokenClaims, loginWithRedirect} = useKensuAuth();

  const auth0Login = () => {
    loginWithRedirect({
      appState: {
        returnTo: window.location.pathname
      },
      authorizationParams: {
        scope: 'openid offline_access' // to get refresh token
      }
    });
  }

  return {
    send: (method: string, request: Uint8Array) => {
      return new Promise((resolve, reject) => {

        getIdTokenClaims().then(token => {

          console.log("[SendRpc] sending " + method + " request");
          const url = getAdminServer() + '/action/' + method;

          const envelope = RequestEnvelopeProto.encode(new RequestEnvelopeProto({
            authToken: token?.__raw,
            requestMessage: request,
          })).finish()

          fetch(url, {
            headers: {
              'Authentication': token?.__raw ?? ''
            },
            method: 'POST',
            body: envelope
          })
              .then(response => {

                // This is unauthorized from our server. This means the auth cookie is no longer valid
                // and an auth0 login is required.
                if (response.status == 401) {
                  console.log('[SendRpc] received ' + method + ' response with status ' + response.status)
                  auth0Login();
                  reject('Please log in.');
                }

                if (response.status != 200) {
                  reject('Status code ' + response.status);
                }

                response.arrayBuffer()
                    .then(buffer => {
                      resolve(new Uint8Array(buffer));
                    })
                    .catch(error => {
                      console.warn("[SendRpc] error reading response body" + method, error);
                      reject('Data read error');
                    });
              })
              .catch(e => {
                console.warn('[SendRpc] error in http layer ' + method, e);
                reject('Network error');
              });
        }).catch(e => {
          reject(e);
        })
      });
    }
  }
}
